import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=e970b726&scoped=true&"
import script from "./ArrowLink.vue?vue&type=script&lang=js&"
export * from "./ArrowLink.vue?vue&type=script&lang=js&"
import style0 from "./ArrowLink.vue?vue&type=style&index=0&id=e970b726&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e970b726",
  null
  
)

export default component.exports